import { getConfig } from '@/config/config.ts';

type LiveTcaLinkButtonProps = {
  tradeId: string;
  hasFxTcaAccess: boolean;
};
const LiveTcaLinkButton = ({ tradeId, hasFxTcaAccess }: LiveTcaLinkButtonProps) => {
  return (
    hasFxTcaAccess && (
      <div className="ms-auto">
        <a
          className="btn btn-flat-primary btn-text-icon btn-sm"
          href={`${getConfig().app.fxtcaUrl}/${tradeId}`}
          target="fxTca"
        >
          FX TCA <i className="icon icon-sm">launch</i>
        </a>
      </div>
    )
  );
};

export default LiveTcaLinkButton;
